module.exports = __webpack_public_path__ + "img/iconliucheng.80db78e1.png";